import React from 'react';
import { useTranslation } from 'react-i18next';

function AssignmentModal({
  isOpen,
  title,
  targetLabel,
  targetName = '-',
  error = '',
  options = [],
  isOptionsLoading = false,
  selectedId = '',
  isSaving = false,
  showUnassign = true,
  onClose,
  onSelect,
  onAssign,
  onUnassign,
}) {
  const { t } = useTranslation();
  const resolvedTitle = title || t('common.assignManager');
  const resolvedTargetLabel = targetLabel || t('common.item');

  if (!isOpen) {
    return null;
  }

  return (
    <>
      <div className="modal fade show d-block" tabIndex="-1" role="dialog" aria-modal="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{resolvedTitle}</h5>
              <button type="button" className="btn-close" onClick={onClose}></button>
            </div>
            <div className="modal-body">
              <div className="mb-2">
                <strong>{resolvedTargetLabel}:</strong> {targetName || '-'}
              </div>
              {error ? <div className="alert alert-danger py-2">{error}</div> : null}
              <label className="form-label">{t('common.managerProfile')}</label>
              <select
                className="form-select"
                value={selectedId}
                onChange={(event) => onSelect(event.target.value)}
                disabled={isOptionsLoading || isSaving}
              >
                <option value="">
                  {isOptionsLoading ? t('common.loadingProfiles') : t('common.selectProfile')}
                </option>
                {options.map((option) => (
                  <option key={option.id} value={option.id}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>
            <div className="modal-footer">
              {showUnassign ? (
                <button
                  type="button"
                  className="btn btn-danger me-auto"
                  onClick={onUnassign}
                  disabled={isSaving}
                >
                  {t('common.unassign')}
                </button>
              ) : null}
              <button
                type="button"
                className="btn btn-primary"
                onClick={onAssign}
                disabled={isSaving || !selectedId}
              >
                {t('common.assign')}
              </button>
              <button
                type="button"
                className="btn btn-default"
                onClick={onClose}
                disabled={isSaving}
              >
                {t('common.close')}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </>
  );
}

export default AssignmentModal;
